import { useCallback, useEffect } from 'react';

const useUnloadConfirm = isDataEmpty => {
  const unloadHandle = useCallback(
    e => {
      e.preventDefault();
      if (!isDataEmpty) {
        e.returnValue = '';
      }
    },
    [isDataEmpty],
  );

  useEffect(
    () => {
      window.addEventListener('beforeunload', unloadHandle);
      return () => {
        window.removeEventListener('beforeunload', unloadHandle);
      };
    },
    [unloadHandle],
  );
};

export default useUnloadConfirm;
